import React from 'react';
import MenuList from './MenuList';
import MenuElement from './elements/MenuElement';
import Profile from './elements/Profile';
import MyAccount from '../../../../assets/images/sidebarIcons/account.svg';
import Help from '../../../../assets/images/sidebarIcons/help.svg';
import RoutesPaths from '../../../../RoutesPaths';
import MobileMenuIcon from '../../../Global/MobileMenuIcon';

const Sidebar = ({ setDisplayMenu, isActiveMenu }) => {
  return (
    <div className='sidebar-container'>
      <nav>
        <div className='close-button-container'>
          <MobileMenuIcon
            setDisplayMenu={setDisplayMenu}
            isActiveMenu={isActiveMenu}
          />
        </div>
        <ul className='sidebar-nav-list'>
          {MenuList.map((element, index) => {
            return (
              <MenuElement
                key={index}
                {...element}
              />
            );
          })}
          <MenuElement
            title={'Moje konto'}
            image={MyAccount}
            url={RoutesPaths.Shop.path}
          />
          <MenuElement
            title={'Pomoc'}
            image={Help}
            url={RoutesPaths.Help.path}
          />
        </ul>
      </nav>
      <Profile />
    </div>
  );
};

export default Sidebar;
